import React from 'react'
import classnames from 'classnames'

interface FeatureSelectionCardProps {
  readonly id: string
  readonly icon: string
  readonly title: string
  readonly subtitle: string
  readonly selected: boolean
  readonly disabled?: boolean
  onClick(): void
}

const FeatureSelectionCard: React.FC<FeatureSelectionCardProps> = (props) => {
  const { id, icon, title, subtitle, selected, disabled = false, onClick } = props

  return (
    <button
      type="button"
      data-testid={`quickstart-select-${id}`}
      className={classnames(
        'QuickStart__feature-card',
        {
          'QuickStart__feature-card-selected': selected,
          'QuickStart__feature-card-disabled': disabled,
        }
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="QuickStart__feature-card-icon">{icon}</div>
      <div className="QuickStart__feature-card-title">{title}</div>
      <div className="QuickStart__feature-card-subtitle">{subtitle}</div>
      {selected && <div className="QuickStart__feature-card-check">✓</div>}
    </button>
  )
}

export default FeatureSelectionCard
